import { isRedlineAgentRole } from "./redline-apply-outcome";
import { createRedlineAttemptRecorder } from "./redline-apply-recorder";
import { startApplyAttempt } from "./redline-snapshot";

export interface AgentScriptOutcome {
    script: string;
    stdout: string;
    error: Error | null;
    agentRole: string | undefined;
}

export async function reportAgentScriptOutcome({
    script,
    stdout,
    error,
    agentRole,
}: AgentScriptOutcome): Promise<void> {
    const recorder = createRedlineAttemptRecorder({
        initiatedFrom: "execute_js",
        agentRole: isRedlineAgentRole(agentRole) ? agentRole : null,
    });

    if (error) {
        recorder.recordFailureAndKeepItsSnapshotId({
            applyContext: startApplyAttempt({ capture: { status: "not_captured" }, reviewId: null }),
            failure: { stage: "execute_js_failed", script, stdout, scriptError: error.message },
            error,
        });
    }

    recorder.recordAttemptEndedAs(error ? "hard_failure" : "applied_clean");
    await recorder.whenEveryRecordingHasSettled();
}
